"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUsdRate = exports.isNativeEvmAsset = exports.usdcContractFromChainId = exports.baseUrlFromChainId = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const types_1 = require("@shapeshiftoss/types");
const api_1 = require("../../../../api");
const bignumber_1 = require("../../../utils/bignumber");
const zrxService_1 = require("../zrxService");
const baseUrlFromChainId = (chainId) => {
    switch (chainId) {
        case types_1.KnownChainIds.EthereumMainnet: {
            return 'https://api.0x.org/';
        }
        case types_1.KnownChainIds.AvalancheMainnet:
            return 'https://avalanche.api.0x.org/';
        default:
            throw new api_1.SwapError(`baseUrlFromChainId] - Unsupported chainId: ${chainId}`, {
                code: api_1.SwapErrorTypes.UNSUPPORTED_CHAIN,
            });
    }
};
exports.baseUrlFromChainId = baseUrlFromChainId;
const usdcContractFromChainId = (chainId) => {
    switch (chainId) {
        case types_1.KnownChainIds.EthereumMainnet: {
            return '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48';
        }
        case types_1.KnownChainIds.AvalancheMainnet:
            return '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e';
        default:
            throw new api_1.SwapError(`usdcContractFromChainId] - Unsupported chainId: ${chainId}`, {
                code: api_1.SwapErrorTypes.UNSUPPORTED_CHAIN,
            });
    }
};
exports.usdcContractFromChainId = usdcContractFromChainId;
const isNativeEvmAsset = (assetId) => {
    const { chainId } = (0, caip_1.fromAssetId)(assetId);
    switch (chainId) {
        case types_1.KnownChainIds.EthereumMainnet:
            return assetId === caip_1.ethAssetId;
        case types_1.KnownChainIds.AvalancheMainnet:
            return assetId === caip_1.avalancheAssetId;
        default:
            return false;
    }
};
exports.isNativeEvmAsset = isNativeEvmAsset;
const getUsdRate = async (asset) => {
    const { assetReference: erc20Address, assetNamespace } = (0, caip_1.fromAssetId)(asset.assetId);
    const { symbol } = asset;
    try {
        const USDC_CONTRACT_ADDRESS = (0, exports.usdcContractFromChainId)(asset.chainId);
        if ((erc20Address === null || erc20Address === void 0 ? void 0 : erc20Address.toLowerCase()) === USDC_CONTRACT_ADDRESS)
            return '1'; // Will break if comparing against usdc
        const baseUrl = (0, exports.baseUrlFromChainId)(asset.chainId);
        const zrxService = (0, zrxService_1.zrxServiceFactory)(baseUrl);
        const rateResponse = await zrxService.get('/swap/v1/price', {
            params: {
                buyToken: USDC_CONTRACT_ADDRESS,
                buyAmount: '1000000000',
                sellToken: assetNamespace === 'erc20' ? erc20Address : symbol,
            },
        });
        const price = (0, bignumber_1.bnOrZero)(rateResponse.data.price);
        if (!price.gt(0))
            throw new api_1.SwapError('[getUsdRate] - Failed to get price data', {
                code: api_1.SwapErrorTypes.RESPONSE_ERROR,
            });
        return (0, bignumber_1.bn)(1).dividedBy(price).toString();
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[getUsdRate]', {
            cause: e,
            code: api_1.SwapErrorTypes.USD_RATE_FAILED,
        });
    }
};
exports.getUsdRate = getUsdRate;
